import { FC } from 'react'

import ModalDeleteDashboard from './ModalDeleteDashboard'
import ModalRenameDashboard from './ModalRenameDashboard'

const PageHeaderDashboardMenuModals: FC = () => {
  return (
    <>
      <ModalRenameDashboard />
      <ModalDeleteDashboard />
    </>
  )
}

export default PageHeaderDashboardMenuModals
